import React from 'react'
import { ResponsivePageContainer } from '../../components/PageContainers'

import { StripeCheckout } from '../../components/Payments/StripeCheckout'



export const BillPay = () => {
    return <ResponsivePageContainer
            title="Bill Pay"
        >
            <StripeCheckout />
        </ResponsivePageContainer>
}